// The people the photo galleries show (About `mix`, Careers `staff`, the
// request-info modal `studentsInfo`; `profs` is unused since /professors
// dropped its gallery, `students` since Tuition's Phase 6 hero). Moved out of
// GalleryScroller.js in Phase 5 PR 5.4; the pages draw them on the Helios
// PhotoMosaic (`galleryMosaicItems`, Phase 5 follow-up, O229 B). Each type is
// a list of columns, each column a list of people, in the order the legacy
// gallery rendered them.

// prof images
import DarienJohnson from '@/public/images/professors/darien-johnson_grid.jpg'
import AdamNavarro from '@/public/images/professors/adam-navarro_grid.jpg'
import ReginaldDuhe from '@/public/images/professors/reginald-duhe_grid.jpg'
import LeeSeanHuang from '@/public/images/professors/lee-sean_grid.jpg'
// student images
import MaxwellK from '@/public/images/students/maxwell-k_grid.jpg'
import Tarik from '@/public/images/students/tarik-freshman_grid.jpg'
import JosephineLentner from '@/public/images/students/josephine-lentner_grid.jpg'
import AlejandroM from '@/public/images/students/alejandro_grid.jpg'
import SkylaW from '@/public/images/students/skyla-freshman_grid.jpg'
import PrincessW from '@/public/images/students/princess_grid.jpg'
import Bria from '@/public/images/students/bria_grid.jpg'
import Raul from '@/public/images/students/student-raul.jpg'
// About images
import Mateo from '@/public/images/about-grid-1.jpg'
import Reginald from '@/public/images/about-grid-2.jpg'
import Kaari from '@/public/images/about-grid-5.jpg'
import JosephineL from '@/public/images/about-grid-6.jpg'
import Princess from '@/public/images/about-grid-7.jpg'
import Mark from '@/public/images/about-grid-8.jpg'
import LeeSean from '@/public/images/about-grid-10.jpg'
import Leonie from '@/public/images/about-grid-12.jpg'
import Darien from '@/public/images/about-grid-13.jpg'
import Adam from '@/public/images/about-grid-14.jpg'
import Alejandro from '@/public/images/about-grid-16.jpg'
import Tade from '@/public/images/about-grid-17.jpg'
import Tim from '@/public/images/about-grid-18.jpg'
import Marceline from '@/public/images/about-grid-19.jpg'
import Molly from '@/public/images/about-grid-20.jpg'
import Skyla from '@/public/images/about-grid-21.jpg'
import Michael from '@/public/images/michael.png'
import Iris from '@/public/images/about-grid-23.jpg'
import Larry from '@/public/images/larry-richman.jpg'
import Paula from '@/public/images/paula-perez.jpg'
import AlejandroInfo from '@/public/images/learn-grid-1.jpg'
import TarikInfo from '@/public/images/learn-grid-2.jpg'
import MaxwellInfo from '@/public/images/learn-grid-3.jpg'
import BriaInfo from '@/public/images/learn-grid-4.jpg'
import RaulInfo from '@/public/images/learn-grid-5.jpg'

export const profs = [
  // column 1
  [
    {
      name: 'Darien Johnson',
      teachesAt: 'UCLA',
      teachesWhat: 'Success',
      photo: DarienJohnson,
    },
    {
      name: 'Adam Navarro',
      teachesAt: 'USC',
      teachesWhat: 'Business',
      photo: AdamNavarro,
    },
  ],
  // column 2
  [
    {
      name: 'Adam Navarro',
      teachesAt: 'USC',
      teachesWhat: 'Business',
      photo: AdamNavarro,
    },
  ],
  // column 3
  [
    {
      name: 'Reginald Duhé',
      teachesAt: 'UC Berkeley',
      teachesWhat: 'Management',
      photo: ReginaldDuhe,
    },
    {
      name: 'Darien Johnson',
      teachesAt: 'UCLA',
      teachesWhat: 'Success',
      photo: DarienJohnson,
    },
  ],
  // column 4
  [
    {
      name: 'Lee-Sean Huang',
      teachesAt: 'NYU',
      teachesWhat: 'Communications',
      photo: LeeSeanHuang,
    },
  ],
]
export const staff = [
  // column 1
  [
    {
      name: 'Mateo Marcano',
      job: 'Engineering',
      future: 'Engineering',
      photo: Mateo,
    },
    {
      name: 'Michael Zimmerman',
      job: 'President',
      future: 'President',
      photo: Michael,
    },
    {
      name: 'Reginald Duhé',
      teachesAt: 'UC Berkeley',
      teachesWhat: 'Management',
      photo: Reginald,
    },
    {
      name: 'Kaari Casey',
      job: 'Academic Operations',
      future: 'Academic Operations',
      photo: Kaari,
    },
    {
      name: 'Josephine L.',
      year: 'Campus Alumna',
      future: 'Student Affairs',
      photo: JosephineL,
    },
  ],
  // column 2
  [
    {
      name: 'Mark Mashaw',
      job: 'Enrollment & Marketing',
      future: 'Enrollment & Marketing',
      photo: Mark,
    },
    {
      name: 'Paula Perez',
      job: 'Finance',
      future: 'Finance',
      photo: Paula,
    },
    {
      name: 'Lee-Sean Huang',
      teachesAt: 'NYU',
      teachesWhat: 'Communications',
      photo: LeeSean,
    },
    {
      name: 'Leonie De La Cruz',
      job: 'Operations',
      future: 'Operations',
      photo: Leonie,
    },
  ],
  // column 3
  [
    {
      name: 'Darien Johnson',
      teachesAt: 'UCLA',
      teachesWhat: 'College Success',
      photo: Darien,
    },
    {
      name: 'Adam Navarro',
      teachesAt: 'USC',
      teachesWhat: 'Business',
      photo: Adam,
    },
    {
      name: 'Tade Oyerinde',
      job: 'Chancellor',
      future: 'Chancellor',
      photo: Tade,
    },
    {
      name: 'Tim Routowicz',
      job: 'Engineering',
      future: 'Engineering',
      photo: Tim,
    },
  ],
  // column 4
  [
    {
      name: 'Marceline Salomon-DeBrosse',
      job: 'Admissions',
      future: 'Admissions',
      photo: Marceline,
    },
    {
      name: 'Molly Mendoza',
      job: 'Student Affairs',
      future: 'Student Affairs',
      photo: Molly,
    },
    {
      name: 'Iris Hou',
      job: 'Product',
      future: 'Product',
      photo: Iris,
    },
    {
      name: 'Marceline Salomon-DeBrosse',
      job: 'Admissions',
      future: 'Admissions',
      photo: Marceline,
    },
    {
      name: 'Molly Mendoza',
      job: 'Student Affairs',
      future: 'Student Affairs',
      photo: Molly,
    },
  ],
]
export const students = [
  // column 1
  [
    {
      name: 'Maxwell K.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: MaxwellK,
    },
    {
      name: 'Tarik L.',
      year: 'Freshman',
      future: 'Future Venture Capitalist',
      photo: Tarik,
    },
    {
      name: 'Princess W.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: PrincessW,
    },
  ],
  // column 2
  [
    {
      name: 'Josephine L.',
      year: 'Rising Sophomore',
      future: 'Future Entrepreneur',
      photo: JosephineLentner,
    },
    {
      name: 'Alejandro M.',
      year: 'Rising Sophomore',
      future: 'Future Teacher',
      photo: AlejandroM,
    },
    {
      name: 'Skyla W.',
      year: 'Freshman',
      future: 'Future Business Owner',
      photo: SkylaW,
    },
  ],
  // column 3
  [
    {
      name: 'Bria J.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: Bria,
    },
    {
      name: 'Princess W.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: Princess,
    },
    {
      name: 'Raul N.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: Raul,
    },
  ],
]
export const mix = [
  // column 1
  [
    {
      name: 'Mateo Marcano',
      job: 'Engineering Manager',
      future: 'Engineering Manager',
      photo: Mateo,
    },
    {
      name: 'Michael Zimmerman',
      job: 'President',
      future: 'President',
      photo: Michael,
    },
    {
      name: 'Reginald Duhé',
      teachesAt: 'UC Berkeley',
      teachesWhat: 'Management',
      photo: Reginald,
    },
    {
      name: 'Alejandro M.',
      year: 'Rising Sophomore',
      future: 'Future Teacher',
      photo: Alejandro,
    },
    {
      name: 'Kaari Casey',
      job: 'VP, Academic Operations',
      future: 'VP, Academic Operations',
      photo: Kaari,
    },
    {
      name: 'Josephine L.',
      year: 'Rising Sophomore',
      future: 'Future Entrepreneur',
      photo: JosephineL,
    },
  ],
  // column 2
  [
    {
      name: 'Princess W.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: Princess,
    },
    {
      name: 'Mark Mashaw',
      job: 'VP, Enrollment & Communications',
      future: 'VP, Enrollment & Communications',
      photo: Mark,
    },
    // {
    //   name: 'Joe Bogle',
    //   job: 'Student Success Coach',
    //   future: 'Student Success Coach',
    //   photo: Joe,
    // },
    {
      name: 'Paula Perez',
      job: 'VP, Finance',
      future: 'VP, Finance',
      photo: Paula,
    },
    {
      name: 'Lee-Sean Huang',
      teachesAt: 'NYU',
      teachesWhat: 'Communications',
      photo: LeeSean,
    },
    {
      name: 'Leonie De La Cruz',
      job: 'VP, Operations',
      future: 'VP, Operations',
      photo: Leonie,
    },
  ],
  // column 3
  [
    {
      name: 'Darien Johnson',
      teachesAt: 'UCLA',
      teachesWhat: 'College Success',
      photo: Darien,
    },
    {
      name: 'Adam Navarro',
      teachesAt: 'USC',
      teachesWhat: 'Business',
      photo: Adam,
    },
    {
      name: 'Tade Oyerinde',
      job: 'Chancellor',
      future: 'Chancellor',
      photo: Tade,
    },
    {
      name: 'Tim Routowicz',
      job: 'VP, Engineering',
      future: 'VP, Engineering',
      photo: Tim,
    },
    {
      name: 'Maxwell K.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: MaxwellK,
    },
  ],
  // column 4
  [
    {
      name: 'Marceline Salomon-DeBrosse',
      job: 'Admissions Counselor',
      future: 'Admissions Counselor',
      photo: Marceline,
    },
    {
      name: 'Molly Mendoza',
      job: 'Student Affairs Manager',
      future: 'Student Affairs Manager',
      photo: Molly,
    },
    {
      name: 'Skyla W.',
      year: 'Freshman',
      future: 'Future Entrepreneur',
      photo: Skyla,
    },
    {
      name: 'Larry Richman',
      job: 'Director, Campus Sacramento',
      future: 'Director, Campus Sacramento',
      photo: Larry,
    },
    {
      name: 'Iris Hou',
      job: 'Senior Product Manager',
      future: 'Senior Product Manager',
      photo: Iris,
    },
  ],
]
export const studentsInfo = [
  // column 1
  [
    {
      name: 'Alejandro M.',
      year: 'Rising Sophomore',
      future: 'Future Teacher',
      photo: AlejandroInfo,
    },
    {
      name: 'Tarik L.',
      year: 'Freshman',
      future: 'Future Venture Capitalist',
      photo: TarikInfo,
    },
    {
      name: 'Maxwell K.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: MaxwellInfo,
    },
    {
      name: 'Bria J.',
      year: 'Rising Sophomore',
      future: 'Future University Transfer',
      photo: BriaInfo,
    },
  ],
  // column 2
  [
    {
      name: 'Princess W.',
      year: 'Freshman',
      future: 'Future University Transfer',
      photo: PrincessW,
    },
    {
      name: 'Raul N.',
      year: 'Freshman',
      future: 'Future Accountant',
      photo: RaulInfo,
    },
    {
      name: 'Josephine L.',
      year: 'Rising Sophomore',
      future: 'Future Entrepreneur',
      photo: JosephineL,
    },
  ],
]

export const GALLERY_PEOPLE = {profs, staff, students, mix, studentsInfo}

// One mosaic tile's width: `backdrop` in the gallery heroes' band (the
// viewport's full width, styles/GalleryHero.module.scss: four columns from
// md, two below), `modal` in the request-info modal's photo column (the full
// width below lg, half the 992px dialog from lg; two columns).
export const GALLERY_TILE_SIZES = {
  backdrop: '(min-width: 768px) 25vw, 50vw',
  modal: '(min-width: 992px) 240px, 50vw',
}

// The galleries' accessible names.
export const GALLERY_LABELS = {
  mix: 'Campus students, staff and professors',
  profs: 'Campus professors',
  staff: 'The Campus team',
  students: 'Campus students',
  studentsInfo: 'Campus students',
}

/**
 * A gallery's people as PhotoMosaic items, in the legacy order (column by
 * column), with the legacy caption: the name, then what a professor also
 * teaches or a student's year, over the university or role. The alt is the
 * name, as the legacy tiles had it.
 */
export function galleryMosaicItems(type) {
  return (GALLERY_PEOPLE[type] ?? GALLERY_PEOPLE.mix).flat().map(person => ({
    src: person.photo,
    alt: person.name,
    name: person.name,
    detail: person.teachesAt
      ? `Also teaches ${person.teachesWhat} at:`
      : person.year,
    description: person.teachesAt ?? person.future,
  }))
}
